/* =========================================================================
   Vida Nova — searchable, scrollable collection filters
   Enhancement for the Normcore theme's native Shopify filters.

   - Removes the "Show more" clamp and gives each filter a scrollable list
   - Adds a live, accent-insensitive search box to filters with many values
   - Survives the theme's AJAX filter re-renders (and restores what you typed)

   Self-contained: no theme templates or snippets are modified.
   Tuning knobs are at the top.
   ========================================================================= */
(function () {
  'use strict';

  /* ---- tuning ---------------------------------------------------------- */
  var MIN_VALUES_FOR_SEARCH = 8;    // show a search box from this many values up
  var LIST_MAX_HEIGHT       = 260;  // px — height of the scrollable value list
  var SKIP_FILTERS          = [];   // e.g. ['filter.v.option.size'] to opt out entirely

  // Filters that keep the scrollable list but get NO search box.
  // Matched as a substring of the filter's param name (e.g. filter.v.option.size,
  // filter.p.m.shopify.color-pattern), so it works for options and metafields.
  var NO_SEARCH_MATCH       = ['size', 'tamanho', 'color', 'colour', 'cor'];

  /* ---- tiny i18n (matches the storefront language) --------------------- */
  var STRINGS = {
    en: { search: 'Search', none: 'No matches' },
    pt: { search: 'Pesquisar', none: 'Sem resultados' }
  };
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  function t(key) { return (STRINGS[LANG] || STRINGS.en)[key] || STRINGS.en[key]; }

  /* ---- helpers --------------------------------------------------------- */
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function norm(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')  // é -> e, ã -> a
      .replace(/\s+/g, ' ')
      .trim();
  }

  function valueText(item) {
    var label = item.querySelector('label') || item;
    var clone = label.cloneNode(true);
    // drop the product-count badge so "3" doesn't match every brand
    each(clone.querySelectorAll('.filter__counter'), function (el) {
      el.parentNode.removeChild(el);
    });
    return clone.textContent;
  }

  function filterName(details) {
    var input = details.querySelector('input[name^="filter."]');
    return input ? input.name : null;
  }

  function searchAllowed(name) {
    var n = (name || '').toLowerCase();
    for (var i = 0; i < NO_SEARCH_MATCH.length; i++) {
      if (n.indexOf(NO_SEARCH_MATCH[i]) !== -1) return false;
    }
    return true;
  }

  /* remembered across AJAX re-renders, keyed by filter param name */
  var queryMemory = {};
  var focusedFilter = null;

  /* ---- styles ---------------------------------------------------------- */
  function injectStyles() {
    if (document.getElementById('vn-filter-search-styles')) return;
    var css = [
      '.vn-fs { margin: 2px 0 10px; }',
      '.vn-fs__input {',
      '  width: 100%; box-sizing: border-box; font: inherit; color: inherit;',
      '  padding: 7px 10px; background: transparent;',
      '  border: 1px solid rgba(127,127,127,.45); border-radius: 2px;',
      '  -webkit-appearance: none; appearance: none;',
      '}',
      '.vn-fs__input::placeholder { color: inherit; opacity: .5; }',
      '.vn-fs__input:focus { outline: none; border-color: currentColor; }',
      '.vn-fs__input::-webkit-search-cancel-button { cursor: pointer; }',
      '.vn-fs-list {',
      '  max-height: ' + LIST_MAX_HEIGHT + 'px; overflow-y: auto;',
      '  overscroll-behavior: contain; padding-right: 8px;',
      '  scrollbar-width: thin;',
      '}',
      '.vn-fs-list::-webkit-scrollbar { width: 4px; }',
      '.vn-fs-list::-webkit-scrollbar-track { background: transparent; }',
      '.vn-fs-list::-webkit-scrollbar-thumb {',
      '  background: rgba(127,127,127,.5); border-radius: 2px;',
      '}',
      '.vn-fs-hidden { display: none !important; }',
      '.vn-fs__empty { margin: 8px 0 0; opacity: .6; }',
      // stop the theme's collapse animation from re-clamping an expanded list
      '.js-expandable-content[data-expanded="true"] {',
      '  height: auto !important; max-height: none !important; overflow: visible !important;',
      '}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'vn-filter-search-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---- 1. defeat the theme's "Show more" clamp -------------------------- */
  function expandAll(details) {
    var showAll = details.querySelector('sht-show-all-options');
    if (!showAll) return;

    var content = showAll.querySelector('.js-expandable-content');
    if (content) content.setAttribute('data-expanded', 'true');

    each(showAll.querySelectorAll('.d-none-important'), function (el) {
      el.classList.remove('d-none-important');
    });

    var btn = showAll.querySelector('.expandable-content__btn');
    if (btn) btn.style.display = 'none';
  }

  /* ---- 2. add the search box ------------------------------------------- */
  function addSearch(details, items, name) {
    var summary = details.querySelector('summary');
    if (!summary) return;

    var container = items[0].parentElement;
    var groupLabel = summary.textContent.replace(/\s+/g, ' ').trim();

    var wrap = document.createElement('div');
    wrap.className = 'vn-fs';

    var field = document.createElement('input');
    field.type = 'search';
    field.className = 'vn-fs__input';
    field.autocomplete = 'off';
    field.placeholder = t('search') + ' ' + groupLabel.toLowerCase();
    field.setAttribute('aria-label', t('search') + ' ' + groupLabel);
    wrap.appendChild(field);

    var empty = document.createElement('p');
    empty.className = 'vn-fs__empty';
    empty.textContent = t('none');
    empty.hidden = true;

    details.insertBefore(wrap, summary.nextSibling);
    container.parentNode.insertBefore(empty, container.nextSibling);

    // cache the searchable text once per value
    each(items, function (item) {
      item.setAttribute('data-vn-text', norm(valueText(item)));
    });

    function apply() {
      var q = norm(field.value);
      var shown = 0;
      each(items, function (item) {
        var input = item.querySelector('input');
        var checked = !!(input && input.checked);
        var match = !q || item.getAttribute('data-vn-text').indexOf(q) !== -1;
        var show = match || checked;          // never hide an active selection
        item.classList.toggle('vn-fs-hidden', !show);
        if (show) shown++;
      });
      empty.hidden = shown > 0;
      if (name) queryMemory[name] = field.value;
    }

    field.addEventListener('input', apply);
    field.addEventListener('focus', function () { focusedFilter = name; });
    field.addEventListener('blur', function () {
      if (focusedFilter === name) focusedFilter = null;
    });
    field.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();   // don't submit the form
    });

    // restore what was typed before an AJAX re-render blew the field away
    if (name && queryMemory[name]) {
      field.value = queryMemory[name];
      apply();
      if (focusedFilter === name) {
        field.focus();
        try {
          field.setSelectionRange(field.value.length, field.value.length);
        } catch (e) {}
      }
    }
  }

  /* ---- 3. enhance one filter group ------------------------------------- */
  function enhance(details) {
    var name = filterName(details);
    if (!name) return;                              // the sort block
    if (SKIP_FILTERS.indexOf(name) !== -1) return;

    var items = details.querySelectorAll('.filter-form__item');
    if (!items.length) return;                      // price slider, toggles

    var container = items[0].parentElement;
    var wantsSearch = items.length >= MIN_VALUES_FOR_SEARCH && searchAllowed(name);

    // The theme re-renders a filter by replacing the children of <details>,
    // so identity must be proven by our own nodes, never by a flag attribute.
    var listReady = container.classList.contains('vn-fs-list');
    var searchReady =
      !wantsSearch ||
      details.getElementsByClassName('vn-fs').length > 0;
    if (listReady && searchReady) return;

    expandAll(details);
    container.classList.add('vn-fs-list');

    if (wantsSearch &&
        details.getElementsByClassName('vn-fs').length === 0) {
      addSearch(details, items, name);
    }
  }

  /* ---- 4. run, and survive the theme's AJAX re-renders ------------------ */
  var observer = null;
  var pending = null;

  function run() {
    injectStyles();
    each(document.querySelectorAll('details.js-details-filter'), enhance);
  }

  // Debounced, not rAF: the theme re-renders the filter form in more than one
  // batch, so we must stay listening rather than discard pending records.
  // enhance() is idempotent, so the extra pass our own writes trigger is a
  // no-op and the loop settles immediately.
  function scheduleRun() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () {
      pending = null;
      run();
    }, 80);
  }

  function start() {
    run();
    observer = new MutationObserver(scheduleRun);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();